import { useTranslation } from "react-i18next";

// Type-specific fields of an operation on one line through « · », the previous ticker first (AC-10b).
function OperationDetails({ operation }) {
  const { t } = useTranslation();
  const fields = [
    ["previousTicker", operation.previousTicker],
    ...Object.entries(operation.details || {}),
  ].filter(([, value]) => value !== null && value !== undefined && value !== "");

  if (fields.length === 0) return "—";

  return fields
    .map(([key, value]) => `${t(`operationsTimeline.details.${key}`, { defaultValue: key })}: ${value}`)
    .join(" · ");
}

export default OperationDetails;
